import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { ChangeCompany } from './ChangeCompany';
import { getUserByPhoneApi } from '../../utils/apisConsts';

const ChangePendingUserCompany: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get Company',
            content: <GetInfo apiLink={getUserByPhoneApi}  />,
            id: 0,
        },

        {
            title: 'Change Pending User Company',
            content: <ChangeCompany />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};
 
export default ChangePendingUserCompany;
